export default function LogoutIcon() {
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        width="30"
        height="30"
        x="0"
        y="0"
        viewBox="0 0 24 25"
      >
        <g>
          <g fill="#000" fillRule="evenodd" clipRule="evenodd">
            <path
              d="M7.648 5.362a.75.75 0 0 1-.21 1.04 8.25 8.25 0 1 0 9.123 0 .75.75 0 0 1 .83-1.25 9.742 9.742 0 0 1 4.359 8.125c0 5.385-4.365 9.75-9.75 9.75s-9.75-4.365-9.75-9.75a9.742 9.742 0 0 1 4.358-8.124.75.75 0 0 1 1.04.209z"
              fill="currentColor"
              opacity="1"
              data-original="#000000"
            ></path>
            <path
              d="M12 1.527a.75.75 0 0 1 .75.75v8a.75.75 0 0 1-1.5 0v-8a.75.75 0 0 1 .75-.75z"
              fill="currentColor"
              opacity="1"
              data-original="#000000"
            ></path>
          </g>
        </g>
      </svg>
    </>
  );
}
